export const headingText = 'Reset Password';
export const resetPasswordConfirmationText = 'An email has been sent to {email} with the password reset link';
export const backButtonAriaLabel = 'back';
